import React from 'react';
import { connect } from 'react-redux'

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import { TextFieldHelper, CheckboxFieldWrapper } from '../../Components/Fields';
import { doLoad } from '../../Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Table from '../../Components/Table';
import _ from 'lodash';

import moment from 'moment'
import 'moment/locale/de'
moment.locale("de");

const ENDPOINT = "umlaufplan"

const columns = [
    "Kürzel",
    "Name",
    "Von",
    "Bis",
    "Start",
    "Ende",
];


class NewEntry extends Master {

	state = {
		newEntry: {}
	}

    componentDidMount = () => {
        this.props.doLoad({datum: moment(this.props.datum).add(1, 'day').format("YYYY-MM-DD"), kuerzel: this.props.value})
    }

    shouldComponentUpdate(props, state) {
        if(props.datum !== state.datum || props.value !== state.value) {
            this.state.datum = props.datum
            this.state.value = props.value
            props.doLoad({datum: moment(props.datum).add(1, 'day').format("YYYY-MM-DD"), kuerzel: props.value})
            return true
        }
        if(props.umlaufplan !== state.umlaufplan) {
            return true
        }
        if(props.dialogOpen !== state.dialogOpen) {
            this.state.dialogOpen = props.dialogOpen
            return true
        }
    }

    selectDetail = (row) => {
        this.props.selectUmlaufplan(this.props.umlaufplan.data[row])
        this.state.datum = undefined
        this.state.value = undefined
        this.props.handleClickOpen()
    }

	render() {

		var {
			handleClickOpen, dialogOpen, umlaufplan
		} = this.props

        var {
        	newEntry, isLoading
        } = this.state

        var items = []
        if(_.has(this.props, 'umlaufplan.data') && umlaufplan.data.length > 0) {
            umlaufplan.data.forEach((item) => {
                items.push([
                    item.kuerzel === undefined ? "-" : item.kuerzel,
                    item.name === undefined ? "-" : item.name,
                    item.von === undefined ? "-" : moment(item.von).format('L'),
                    item.bis === undefined ? "-" : moment(item.bis).format('L'),
                    item.start === undefined ? "-" : item.start,
                    item.ende === undefined ? "-" : item.ende
                ])
            })
        }

		return (
			<Dialog
                closeAction={handleClickOpen}
                open={dialogOpen}
                noSave
                maxWidth="md"
                loading={umlaufplan.isLoading}
             >
                {!umlaufplan.isLoading && items.length === 0 && <p>Keine Umlaufpläne gefunden!</p>}
				<Table
                    noEmpty
                    noId
                    title="Umlaufpläne"
                    key={"items"+items.length}
                    data={items}
                    classes="umlaufplaene-auswahl"
                    count={umlaufplan === undefined ? 0 : umlaufplan.count}
                    columns={columns}
                    populate={this.populate}
                    rowClick={this.selectDetail}
                    options={{
                        selectableRows: false,
                        customToolbarSelect: this.customToolbarSelect,
                        onRowsSelect: this.onRowsSelect
                    }}
                />
			</Dialog>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doLoad: (filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/list", filter)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewEntry);


// WEBPACK FOOTER //
// ./src/Routes/Umlaufplaene/Auswahl.js